
import { defineComponent } from 'vue';
import {
	organisationSelectorController,
	View,
} from '@/modules/organisations/components/OrganisationSelector.controller';
import SearchField from '@/lib/components/Judging/SearchField.vue';
import { Multiselect, SelectField } from 'vue-bootstrap';
import { useController } from '@/domain/services/Composer';
import EmailsBox from '@/lib/components/Shared/EmailsBox.vue';

export default defineComponent<View>({
	components: {
		Multiselect,
		EmailsBox,
		SearchField,
		SelectField,
	},
	setup: useController(organisationSelectorController, 'OrganisationSelectorController') as () => View,
});
